import React from 'react';
import { getSVGHeight } from '../svg-provider';
import { IIconProps } from '../interfaces';

const EyeIcon = (props: IIconProps) => {

    let height = props.height;

    // if height property is not defined, and width & height should be defined in px ->
    // calculate the height dynamically, keeping the aspect ratio using the viewport
    if(height === undefined && props.width.endsWith('px')){
        height = getSVGHeight(props.width, 19, 12);
    }

    return (
        <svg
            width={ props.width }
            height={ height }
            viewBox="0 0 19 12"
            xmlns="http://www.w3.org/2000/svg"
            className={ props.classes }>
            { props.title && <title>{ props.title }</title> }
            <path d="m17.931 5.721.194.258-.194.258a7.85 7.85 0 0 1-.175.222 17.056 17.056 0 0 1-2.276 2.277c-1.902 1.568-3.922 2.514-5.98 2.514-2.058 0-4.078-.946-5.98-2.514a17.07 17.07 0 0 1-2.276-2.277 7.864 7.864 0 0 1-.175-.222l-.194-.258.194-.258a7.85 7.85 0 0 1 .175-.222A17.056 17.056 0 0 1 3.52 3.222C5.422 1.654 7.442.708 9.5.708c2.058 0 4.078.946 5.98 2.514A17.07 17.07 0 0 1 17.756 5.5c.084.105.144.18.175.222zm-1.19-.217a16.376 16.376 0 0 0-1.707-1.634C13.25 2.398 11.372 1.52 9.5 1.52c-1.873 0-3.75.879-5.534 2.351a16.382 16.382 0 0 0-2.12 2.11A16.376 16.376 0 0 0 3.965 8.09C5.75 9.562 7.627 10.44 9.5 10.44c1.872 0 3.75-.878 5.534-2.35a16.382 16.382 0 0 0 2.12-2.11 14.16 14.16 0 0 0-.413-.475zM9.5 8.005c1.032 0 1.852-.896 1.852-2.026 0-1.114-.828-2.027-1.852-2.027-1.01 0-1.851.922-1.851 2.027 0 1.114.827 2.026 1.851 2.026zm0 .812c-1.434 0-2.592-1.277-2.592-2.838 0-1.553 1.174-2.838 2.592-2.838 1.434 0 2.592 1.277 2.592 2.838 0 1.578-1.15 2.838-2.592 2.838z" fill={ props.color } fillRule="evenodd"/>
        </svg>

    )
};

export default EyeIcon;
